import React, { memo } from "react";
import { HighchartsReact } from "investira.react.charts";

const RegiaoBarChart = memo((props) => {
  const { data = [], title = {} } = props;
  const xOptions = {
    chart: {
      type: "bar",
    },
    title: {
      text: "",
      ...title,
      style: {
        fontSize: "0.85rem",
      },
    },
    series: [
      {
        name: "Percentual",
        colorByPoint: true,
        data: data,
      },
    ],
    xAxis: {
      categories: data.map((xItem) => xItem.name),
      title: {
        text: null,
      },
    },
    yAxis: {
      min: 0,
      title: {
        text: "Percentual (%)",
        align: "high",
      },
      labels: {
        overflow: "justify",
      },
    },
    plotOptions: {
      bar: {
        dataLabels: {
          enabled: true,
          format: " {point.y} %",
          style: {
            color: "white", // Muda a cor do texto para branco
            textOutline: "none", // Remove o outline
          },
        },
      },
    },
    tooltip: {
      formatter: function () {
        return `<b>${this.point.name}</b>: ${this.point.metadata.percentual}</br>`;
      },
    },
    legend: {
      enabled: false, // Desativa a legenda
    },
  };
  return <HighchartsReact options={xOptions} drilldown />;
});

export default RegiaoBarChart;
